import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../Utils/Axios";
import { useNavigate } from "react-router-dom";

const HospitalListing = () => {
  const navigate = useNavigate();
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(true);
  const resolveHospitalLogo = (logo) => logo || "https://api.dicebear.com/9.x/shapes/svg?seed=Hospital";

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/api/admin/hospitals");
      setHospitals(res.data.hospitals || []);
    } catch (err) {
      toast.error("Failed to load hospitals");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const verifyHospital = async (id) => {
    try {
      await api.patch(`/api/admin/hospitals/${id}/verify`);
      toast.success("Hospital verified");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to verify hospital");
    }
  };

  const deleteHospital = async (id) => {
    const ok = window.confirm("Delete this hospital? This will also remove its jobs and payments.");
    if (!ok) return;
    try {
      await api.delete(`/api/admin/hospitals/${id}`);
      toast.success("Hospital deleted");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete hospital");
    }
  };

  return (
    <div className="col-lg-12">
      <div className="table-wrapper2">
        <div className="title-and-btn">
          <div className="title">
            <h4>Hospital Listing</h4>
          </div>
        </div>
        {loading ? (
          <p>Loading hospitals...</p>
        ) : (
          <table className="eg-table table job-list-table mb-0">
            <thead>
              <tr>
                <th>Hospital</th>
                <th>Email</th>
                <th>State</th>
                <th>City</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {hospitals.length === 0 ? (
                <tr>
                  <td colSpan="6">No hospitals found.</td>
                </tr>
              ) : (
                hospitals.map((h) => (
                  <tr key={h._id}>
                    <td>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <img
                          src={resolveHospitalLogo(h.logo)}
                          alt={h.name}
                          style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover" }}
                        />
                        <span>{h.name}</span>
                      </div>
                    </td>
                    <td>{h.email}</td>
                    <td>{h.state || "-"}</td>
                    <td>{h.city || "-"}</td>
                    <td>{h.isVerified ? "Verified" : "Pending"}</td>
                    <td>
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <button className="primry-btn-1" onClick={() => navigate(`/hospital-detail/${h._id}`)}>
                          View
                        </button>
                        {!h.isVerified && (
                          <button className="primry-btn-2" onClick={() => verifyHospital(h._id)}>
                            Verify
                          </button>
                        )}
                        <button className="primry-btn-1" onClick={() => deleteHospital(h._id)}>
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default HospitalListing;
